import { ButtonBase, styled as muiStyled } from '@mui/material'

export const AddPracticeComponentContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    
`,
)

export const AddPracticeListItem = muiStyled(ButtonBase)(
  ({ theme, selected }) => `
    display:flex;
    width: 100%;
    align-items:center;
    justify-content:space-between;
    padding: 10px;
    background: ${selected ? '#53347ec4' : '#9f9f9f1c'};
    color: #fff;
    transition: 400ms all ${theme.transitions.easing.quickInOut};
    border-bottom: 1px solid #0000002f;
    &:hover {
        background-color: ${selected ? '#53347ec4' : '#53347e44'};
    }
`,
)

export const AddPracticeSearchInputContainer = muiStyled('div')(
  ({ theme, invalid }) => `
  display: flex;
  align-items: center;
  background: #535353;
  color: ${invalid ? '#ff6666' : '#fff'};
  padding: 12px 10px;
  margin: 10px 0px;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;

`,
)
